import React, { useState } from 'react';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import tokenapi, { updateGoogleMaps } from '../../../Base/TokenConfig';
import { downloadQr } from '../../../Utils/downloadQr';
import Message from '../../../Layouts/Message/Message';
import styles from '../my-qr-codes.module.css';

export default function LocationDetails(props){
    const singleDetail = props.singleDetail;
    const [title, setTitle] = useState(props.singleDetail.title);
    const [location, setLocation] = useState(props.singleDetail.location);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');

    const updateFunction = (e) => {
        e.preventDefault();
        setLoading(true);
        tokenapi.post(updateGoogleMaps, {
            qrType: props.singleDetail.qrType,
            categoryId: props.singleDetail.categoryId,
            requestId: props.singleDetail.requestId,
            title: title,
            location: location,
            s3Url: props.singleDetail.s3Url,
            encWebUrl: props.singleDetail.encWebUrl
        })
        .then(res => {
            setLoading(false);
            if(res.data.code === 200){
                props.fetchFunction();
                props.closeFunction();
                setMessageType('success');
            } else {
                setMessageType('error');
            }
            setMessage(res.data.message);
        })
        .catch(err => {
            setLoading(false);
            console.error(err);
        })
    }

    const handlePlaceSelect = (place) => {
        setLocation(place.label);
    };

    return (<>
        {message && <Message type={messageType} message={message} closeMessage={() => setMessage('')} />}
        <div className={styles["vcard-static-content"]}>
            <div>
                <img src={singleDetail.s3Url} alt="qr" />
            </div>
            <div>
                <p><span>Category:</span> {singleDetail.categoryName}</p>
                <p><span>Created on:</span> {`${new Date(singleDetail.createdAt)}`.substr(0, 24)}</p>
                <button className="btn btn-primary" onClick={() => downloadQr(singleDetail.s3Url)}><span className="fa fa-download"></span> Download QR</button>
            </div>
        </div>
        <form onSubmit={updateFunction}>
            <div className={styles["vcard-editable-content"]}>
                <p className={styles["modal-subheading"]}>Edit details</p>
                <label>Title</label>
                <input type="text" placeholder="Enter here" value={title} onChange={(e) => setTitle(e.target.value)} required/>
                <label>Location*</label>
                <GooglePlacesAutocomplete
                    apiKey={process.env.REACT_APP_GOOGLE_PLACES}
                    selectProps={{
                        placeholder: 'Enter a location',
                        onChange: handlePlaceSelect
                    }}
                />
                <button className="btn btn-primary mt-3" disabled={loading}>{loading ? 'Wait ...' : 'Submit'}</button>
            </div>
        </form>
    </>)
}